<div class="row">
    <div class="col-12 form-check px-0 mt-3" *ngIf='privacyCheckBox'>
        <label tabindex="0" class="check-lbl form-check-box">
            <input tabindex="-1" role="checkbox" type="checkbox" (change)="setPrivacyPreference($event)"
                class="check-box" name="" value="true" id="" [checked]="!privacyPreference">
            <span class="label-text"></span><span class="form-check-text">{{'checkout.Customer agrees to share their contact information with Sponsor' | translate | translateKey}}
            </span>
        </label>
    </div>
</div>
<div class="row">
    <div class="col-12 form-check px-0 mt-3" *ngFor="let agreement of agreementDocuments;let i = index;">
        <label tabindex="-1" class="check-lbl form-check-box">
            <input role="checkbox" type="checkbox" aria-label="" (change)="onChangeAgreements(i);" class="check-box"
                name="" value="true" id="" [checked]="agreementDocuments[i].isSelected">
            <span class="label-text"></span><span
                class="form-check-text">{{'checkout.I agree to' | translate | translateKey}}
                <span *ngIf="!(agreement?.documentUrl)">{{agreement?.displayName}}</span>
                <span (click)="$event?.stopPropagation();" *ngIf="agreement?.documentUrl">
                    <a class="align-top link--light d-inline-block view-policies" target="_blank"
                        [href]="agreement?.documentUrl">{{agreement?.displayName}}</a>
                </span>
            </span>
        </label>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/enrollment/documents.component.html